import React, { SVGProps } from "react";

function LinkInputIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12.467"
      height="12.47"
      viewBox="0 0 12.467 12.47"
      style={{ overflow: "visible" }}
      fill="currentColor"
      {...props}
    >
      <path
        id="Icon_metro-link"
        data-name="Icon metro-link"
        d="M8.274,10.068a.646.646,0,0,1-.459-.19,3.046,3.046,0,0,1,0-4.3L10.21,3.181a3.043,3.043,0,1,1,4.3,4.3L13.418,8.578a.648.648,0,0,1-.917-.917L13.6,6.567A1.746,1.746,0,0,0,11.127,4.1L8.733,6.492a1.748,1.748,0,0,0,0,2.469.648.648,0,0,1-.458,1.107Zm-2.3,4.692A3.043,3.043,0,0,1,3.825,9.565L4.92,8.471a.648.648,0,0,1,.917.917L4.742,10.482a1.746,1.746,0,0,0,2.469,2.469l2.394-2.394a1.748,1.748,0,0,0,0-2.469.648.648,0,1,1,.917-.917,3.046,3.046,0,0,1,0,4.3L8.128,13.868a3.023,3.023,0,0,1-2.152.891Z"
        transform="translate(-2.936 -2.29)"
      />
    </svg>
  );
}

export default LinkInputIcon;
